import { render, staticRenderFns } from "./DashboardUserInfoListItem.vue?vue&type=template&id=6de8a762"
import script from "./DashboardUserInfoListItem.vue?vue&type=script&lang=js"
export * from "./DashboardUserInfoListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports